import './highcharts';
import 'highcharts/es-modules/masters/modules/heatmap.src.js';
import { Chart } from './Chart';
import type { ChartProps } from './Chart';

/**
 * Loads the Highcharts heatmap module before rendering the shared Seeq chart
 * wrapper.
 */
export const HeatmapChart = ({ onReady, options, ...rest }: ChartProps) => {
  return <Chart {...rest} options={options} onReady={onReady} />;
};
